<template>
  <div>
    <!-- 短信统计 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>短信统计</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="tab">
      <span
        v-for="(v,i) in tabBtn"
        :key="v.id"
        @click="tabTitle(i)"
        :class="activeIndex==i?'activeTab':''"
      >{{v.name}}</span>
    </div>
    <!-- <el-card> -->
    <!-- 自助充值 -->
    <div v-if="activeIndex==0">
      <div class="ziZhuCZ">
        <div class="zCLeft">
          <div>订单短信</div>
          <el-divider></el-divider>
          <el-form ref="form" :model="form" label-width="80px">
            <div class="itemOne">
              <el-form-item label="计费类型:">
                <el-input v-model="charge_des" placeholder="计费类型" disabled></el-input>
              </el-form-item>
              <div>
                <el-form-item label="单价:">
                  <span>{{charge_price}}</span>
                </el-form-item>
              </div>
              <div class="charge">
                <el-form-item label="当前余额:" >
                  <el-input v-model="Balance" disabled placeholder="当前余额"></el-input>
                  <span>元</span>
                </el-form-item>
              </div>
            </div>
            <div class="itemTwo">
              <el-form-item label="充值金额:" v-if="type=='1'">
                <el-input v-model="price" placeholder="充值金额"  @change="inputPrice"></el-input>
                <span>元</span>
              </el-form-item>
              <el-form-item label="充值天数:" v-if="type=='2'">
                <el-input v-model="price" placeholder="充值天数" @change="inputPrice"></el-input>
                <span>天</span>
              </el-form-item>
              <el-form-item label="合计:">
                <el-input v-model="form.chargeBal" disabled placeholder="合计"></el-input>
                <span>元</span>
              </el-form-item>
            </div>
            <el-form-item label="支付方式:">
              <el-radio-group v-model="form.payMode">
                <el-radio label="2">微信支付</el-radio>
                <el-radio label="3">支付宝支付</el-radio>
                <el-radio label="4">汇款支付</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="btn">
              <el-button @click="clearCh">清空</el-button>
              <el-button class="btnL" @click="Recharge">确认提交</el-button>
            </el-form-item>
          </el-form>
          
        </div>
        <div class="zCLeft">
          <div>群发短信</div>
          <el-divider></el-divider>
          <el-form ref="form" :model="form" label-width="80px">
            <div class="itemOne">
              <el-form-item label="计费类型:">
                <el-input disabled  placeholder="计费"></el-input>
              </el-form-item>
              <div>
                <el-form-item label="单价:">
                  <span>{{qf_Balance}} {{ charge_des=='计费'?'元/条':'元/条' }}</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="当前余额:">
                  <el-input v-model="qf_account" disabled placeholder="当前余额"></el-input>
                  <span>元</span>
                </el-form-item>
              </div>
            </div>
            <div class="itemTwo">
              <el-form-item label="充值金额:">
                <el-input v-model="hairMoney" placeholder="充值金额"  @change="inputPrice1"></el-input>
                <span>元</span>
              </el-form-item>
              <!-- <el-form-item label="充值天数:" v-if="type=='2'">
                <el-input v-model="hairMoney" placeholder="充值天数" @change="inputPrice1"></el-input>
                <span>天</span>
              </el-form-item> -->
              <!-- <el-form-item label="充值金额:">
                <el-input v-model="hairMoney" placeholder="充值金额"></el-input>
                <span>元</span>
              </el-form-item> -->
              <el-form-item label="合计:">
                <el-input v-model="hairMon" disabled placeholder="合计"></el-input>
                <span>元</span>
              </el-form-item>
            </div>
            <el-form-item class="Botm" label="支付方式:">
              <el-radio-group v-model="radio">
                <el-radio label="2">微信支付</el-radio>
                <el-radio label="3">支付宝支付</el-radio>
                <el-radio label="4">汇款支付</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="btnS">
              <el-button @click="clearqf">清空</el-button>
              <el-button class="btnL" @click="hairClick">确认提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 充值统计 -->
    <div v-if="activeIndex==1">
      <el-card>
        <div class="balance" v-if="charge=='2'">
          <span>系统使用时间:</span>
          <span>{{scenicbalance}}</span>
        </div>
        <div  class="balance"   v-else>
          <span>当前剩余余额:</span>
          <span >{{scenicbalance}}</span>
          <span>元</span>
        </div>
        <el-row class="conentRow">
          <el-date-picker
            v-model="SMStime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="data1.status" filterable clearable placeholder="状态">
            <el-option
              v-for="item in statusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary" @click="RechargeBtns">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column label="收费类别">
            <template slot-scope="scope">
              <span>{{ scope.row.sms_type=='1'?"订单短信":"群发短信" }}</span>
            </template>
          </el-table-column>
          <el-table-column  label="计费类型">
            <template slot-scope="scope">
              <span>{{ scope.row.sms_type=='1'?"计费（元）":"计时" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Pay" label="充值数量"></el-table-column>
          <el-table-column prop="Balance" label="充后余额"></el-table-column>
          <el-table-column prop="username" label="操作人"></el-table-column>
          <el-table-column prop="PayTime" label="充值时间"></el-table-column>
          <el-table-column label="支付方式">
            <template slot-scope="scope">
              <span>{{ scope.row.pay_mode=='1'?"无":scope.row.pay_mode=='2'?"微信支付":scope.row.pay_mode=='3'?"支付宝支付":'汇款支付' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="jfy_amount" label="支付金额"></el-table-column>
          <el-table-column  label="充值状态">
            <template slot-scope="scope">
              <span>{{ scope.row.status=='1'?"已到账":scope.row.status=='2'?"审核中":scope.row.status=='3'?"未通过":'未到账' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <span>-</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total1}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total1" @current-change="Rechange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- </el-card> -->
    <!-- 充值统计结束 -->
    <!-- 短信统计开始 -->
    <div v-if="activeIndex==2">
      <div class="navFrame">
        <div class="navDataBig">
          <div v-for="v in navList" :key="v.id" @click="noteTem(v.id)">
            <div>{{v.title}}</div>
            <div>
              <span>
                <span>{{(v.navTotal)}}</span>
                <!-- <span>{{v.Company}}</span> -->
              </span>
              <img :src="v.srcUrl" alt />
            </div>
          </div>
        </div>
      </div>
      <el-card>
        <el-row class="conentRow">
          <el-date-picker
            v-model="dataTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-select v-model="data.distributorid" filterable clearable placeholder="全部分销商">
            <el-option
              v-for="item in options"
              :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID"
            ></el-option>
          </el-select>
          <el-button class="conentBtn" type="primary" @click="setDisSMS">查询</el-button>
        </el-row>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="Name" label="分销商名称"></el-table-column>
          <el-table-column prop="num" label="短信使用数量"></el-table-column>
          <el-table-column prop="refund_count" label="退款数量"></el-table-column>

          <el-table-column prop="address" label="操作"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="openClick(scope.row)">退款明细</el-button>
              <el-button type="text" @click="noteFn(scope.row)">详细信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="total" @current-change="list"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </el-card>
    </div>
    <!-- 短信统计结束 -->
    <div v-if="activeIndex==3" class="setNotes">
      <div class="balance" v-if="charge=='2'">
        系统使用时间: <span>{{scenicbalance}}</span>
      </div>
      <div class="balance" v-else>
        系统短信余额: <span>{{scenicbalance}}</span> 元
      </div>
      <div class="noteMObile">
        <div class="noteMObileOne">
          <div>
            <span>短信模板内容</span>
            <span>(使用中)</span>
          </div>
          <div>{{NoteSet.Sms}}</div>
        </div>
        <div class="noteMObileTwo">
          <div>
            <span>新短信模板内容</span>
            <span>({{NoteSet.ExamineSmsStatus=='1'?'审核成功':NoteSet.ExamineSmsStatus=='2'?'待审核':'未通过审核'}})</span>
          </div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows:6, maxRows: 6}"
              v-model="ExamineSms"
              placeholder="请输入新短息模板内容"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="noteFrom">
        <el-form ref="form" :model="form" label-width="200px">
          <div class="notetitle">
            <span>系统余额提醒设置</span>
            <span>注:</span>
            <span>频次限制默认3次/天,计时默认结束三天前提醒,设置不得大于6</span>
          </div>
          <el-form-item label="首次提醒额度:">
            <span class="xingA">*</span>
            <el-input v-model="NoteSet.fbalance" placeholder="数量"></el-input>
            <span class="Left5">元</span>
          </el-form-item>
          <el-form-item label="最低提醒额度:">
            <span class="xingA">*</span>
            <el-input v-model="NoteSet.lbalance" placeholder="数量"></el-input>
            <span class="Left5">元</span>
          </el-form-item>
          <el-form-item label="频次限制:">
            <span class="xingB">*</span>
            <el-input v-model="NoteSet.frequency" placeholder="数量"></el-input>
            <span class="Left5">次/天</span>
          </el-form-item>
          <el-form-item label="景区微商城是否发送短信:">
            <el-radio-group v-model="NoteSet.sms_flag">
              <el-radio label="1">发送</el-radio>
              <el-radio label="2">不发送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button class="btnL" @click="settings">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="activeIndex==4" class="setNotes"> 
      <div class="editMsgFrom">
        <el-form ref="form" :model="form" label-width="130px">
          <div class="itemtimes">
            <el-form-item label="[日历票]游玩时间:">
              <div class="reports">
                <el-date-picker
                  v-model="value1"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </div>
              <div class="itemOne">
                <span>注:</span>
                <span>短信会发送给该使用时间段内的用户</span>
              </div>
            </el-form-item>
            <el-form-item label="期票导出:">
              <div class="reports">
                <span style="margin-right:1rem;">当前</span>
                <el-input
                  v-model="days"
                  placeholder="请输入期票导出天数"
                ></el-input>
                <span style="margin-left:1rem;">天前</span>
              </div>
              <div class="itemOne">
                <span>注:</span>
                <span>短信会发送给该时段内购买的用户</span>
              </div>
            </el-form-item>
          </div>
      
          <div>
            <el-form-item label="订单状态:">
              <el-radio-group v-model="type">
                <el-radio :label="1">全部订单</el-radio>
                <el-radio :label="2">未使用订单</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="">
              <el-button class="btnL" @click="reportClick">导出订单联系方式</el-button>
              <span style="margin-left:2rem;color:red;font-size:1.6rem;">已导出手机号请联系技术</span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="编辑短信内容:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 9, maxRows: 15}"
                v-model="dataqf.description"
                placeholder="请输入短信内容"
              ></el-input>
              <div class="itemOne">
                <span>注:</span>
                <span>短信会发送给该使用时间段内的用户,短信最长50个字符，超出字符按照两条短信收费</span>
              </div>
            </el-form-item>
          </div>
          
          
          <el-form-item>
            <div class="btn">
             
              <el-button class="btnL" @click="btns">保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="activeIndex==5" class="setNotes">
      <div class="noteMObile">
        <div class="noteMObileTwo ">
          <div>
            <span>新退款短信模板内容(使用中)</span>
            <span></span>
          </div>
          <div>
            <el-input
              type="textarea"
              disabled
              v-model="datatks.Sms"
              :autosize="{ minRows: 6, maxRows: 10}"
              placeholder="请输入新退款短信模板内容"
            ></el-input>
          </div>
        </div>
        <div class="noteMObileTwo " style="margin-left:2rem;"> 
          <div>
            <span>退款短信模板内容(待审核)</span>
            <span></span>
          </div>
          <div>
            <el-input
              type="textarea"
              v-model="datatks.text"
              :autosize="{ minRows: 6, maxRows: 10}"
              placeholder="请输入新退款短信模板内容"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="noteFrom">
        <el-form ref="form" :model="datatks" >
          <el-form-item label="退款是否发送短信:">
            <el-radio-group  v-model="datatks.sms_flag">
              <el-radio label="1">发送</el-radio>
              <el-radio label="2">不发送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button class="btnL" @click="settiTuikun">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 销售统计查看详情开始 -->
    <noteStaDialog v-if="noteTjvisible" ref="noteTjDialog" :noteId="noteId" @noteClose="notClose"></noteStaDialog>
    <!-- 销售统计查看详情结束 -->
    <div v-show="Visible" class="mask">
        <div class="mask_box">
          <div class="mask_title">
             微信扫码支付
             <img src="@/images/distributor/Grou.png" alt="" @click="closeFlag">
          </div>
          <div class="qrcode" ref="qrCodeUrl" id="qrcode"></div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeFlag">取 消</el-button>
            <el-button type="primary" @click="payment">确 定</el-button>
          </span>
        </div>
    </div>
    <el-dialog :close-on-click-modal="false"  
      title="汇款支付"
      :visible.sync="remittance"
      :before-close="remiHandleClose"
      width="40.8%"
      center
    >
      <el-divider></el-divider>
      <el-form>
        <div class="mayMode">
          <div>收款方信息</div>
          <div>
            <div>
              <el-descriptions :column="1" direction="vertical">
                <el-descriptions-item label="收款账户">{{remi.jfyName}}</el-descriptions-item>
                <el-descriptions-item label="收款方开户行">{{remi.jfyAccountBank}}</el-descriptions-item>
                <el-descriptions-item label="收款方账户">{{remi.jfyAccount}}</el-descriptions-item>
              </el-descriptions>
              <!-- <div class="remiFlex">
                <span>收款账户：</span> <span>{{remi.jfyName}}</span>
                <span>收款方开户行：</span> <span>{{remi.jfyAccountBank}}</span>
                <span>收款方账户：</span> <span>{{remi.jfyAccount}}</span>
              </div> -->
            </div>
            <div>
              <span>注:</span>
              <span>您需要汇款--元至下一账户,汇款成功后上传凭证信息,审核通过后到账.</span>
            </div>
          </div>
        </div>
        <div class="fukuanfang">付款方信息</div>
        <div class="itemFour">
          <div>
            <el-form-item label="付款户名:">
              <el-input  v-model="formremi.remitName" placeholder="请输入付款户名"></el-input>
            </el-form-item>
            <el-form-item label="付款账户:">
              <el-input  v-model="formremi.remitCode" placeholder="请输入付款账户"></el-input>
            </el-form-item>
            <el-form-item label="付款时间:">
              <el-date-picker
                v-model="formremi.remitDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="付款凭证:">
              <el-upload class="avatar-uploader" action="http://xwt.softykt.net/api/scenic/uploadRemitImg" :show-file-list="false"
                  :on-success="handlePreviewVide" :data="headers">
                  <i slot="default" class="el-icon-plus" v-if="formremi.remitImg==''"></i>
                  <div v-else>
                    <img class="el-upload-list__item-thumbnail" :src="formremi.remitImg" alt />
                  </div>
              </el-upload>
              <!-- <el-upload disabled action=""
               list-type="picture-card" :auto-upload="false"
               :on-success="">
                <i slot="default" class="el-icon-plus" v-if="formremi.remitImg==''"></i>
                <div v-else>
                  <img class="el-upload-list__item-thumbnail" :src="formremi.remitImg" alt />
                </div>
              </el-upload> -->
              <div class="zhu">
                <span style="margin-right:10px">注:</span>
                <span>付款凭证图片,支持jpg,jpeg.png格式,图片不超过5MB</span>
              </div>
            </el-form-item>
          </div>
        </div>
        <el-form-item class="btnS">
          <el-button class="btnL" @click="remiClick">确认提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  
      title="退款明细"
      :visible.sync="show"
      :before-close="refundClose"
      width="85.8%"
      center
    >
      <el-divider></el-divider>
      <div class="titleZxtj">
        <el-date-picker
          v-model="valuerefund"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-button @click="reclick">查询</el-button>
        <el-button class="Dcb" @click="reportClickrefund">去导出</el-button>
      </div>
      <div >
        <el-table
          :data="tableDatarefund"
          style="width: 100%"
          v-loading="loading"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column prop="scenic_id" label="景区id"></el-table-column>
          <el-table-column prop="d_name" label="分销商名称"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="OrderNumber" label="订单号"></el-table-column>
          <el-table-column prop="created_at" label="创建时间"></el-table-column>
        </el-table>
            <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{totalreund}}条记录，</span>
          <span class="demonstration">当前显示第{{datare.page}}页</span>
          <el-pagination background layout="prev, pager, next" :total="totalreund" @current-change="Listrefund"></el-pagination>
        </div>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import noteStaDialog from "./dialog/noteStaDialog.vue";
import { DisSMSstatistics,
  getScenicListDistrbutor,
  ScenicSMSstatistics,
  SMSstatistics,
  GetSMStopup,
  SetSMStopup,
  PaySMS,
  getPayInfo,
  remitApi,
  GetScenicNote,
  ScenicNoteSet,
  ScenicMessage,
  MasstextingSms,
  getSmsTemplate,
  setSmsTemplate,
  exportMobile,
  addQfTemplate,
  getQfTemplate,
  refundSmsOrderList,
  exportRefundSmsOrder
} from '@/request/scenic.js'
import QRCode from 'qrcodejs2'
import {MessageBox,Message} from 'element-ui'
export default {
  components: {
    noteStaDialog
  },
  data() {
    return {
      value1:'',
      remittance:false,
      Visible:false,
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      noteTjvisible: false, // 短信统计详情明细
      tableData: [
      ],
      tabBtn: [
        {
          id: 1,
          name: "自助充值"
        },
        {
          id: 2,
          name: "充值统计"
        },
        {
          id: 3,
          name: "短信统计"
        },
        {
          id: 4,
          name: "短信设置"
        }
        ,
        {
          id: 5,
          name: "群发短信"
        },
        {
          id: 6,
          name: "退款短信设置"
        }
      ],
      form: {
        token:window.sessionStorage.getItem('Token'),
        type:'1',
        chargeTime:'',
        payMode:'2',
        chargeBal:'',
        qfBal:'',
      },
      radio: "2",
      value: "",
      activeIndex: "2", // 选中tab
      navList: [
        
      ],
      options: [
      ],
      value: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        distributorid:'',
        starttime:'',
        endtime:'',
        page:1,
        page_size:10
      },
      total:0,
      dataTime:'',
      noteId:'',
      data1:{
        token:window.sessionStorage.getItem('Token'),
        starttime:'',
        endtime:'',
        status:'',
        page:1,
        page_size:10
      },
      statusOption:[
        {
          value:1,
          label:'已到账'
        },
        {
          value:2,
          label:'审核中'
        }
        // {
        //   value:3,
        //   label:'未通过'
        // },
        // {
        //   value:4,
        //   label:'未到账'
        // }
      ],
      total1:0,
      SMStime:'',
      loading:true,
      charge_des:'',// 充值类型 计费计时
      Balance:'',// 余额
      charge_price:'', // 单价
      commission:'', // 单价
      price:'', // 充值金额/天数
      type:'1',
      hairMoney:'',
      hairMon:'',
      hairMonTime:'',
      remi:{
        jfyAccount:'',
        jfyAccountBank:'',
        jfyName:''
      },
      formremi:{
        token:window.sessionStorage.getItem('Token'),
        remitName:'',
        remitCode:'',
        remitDate:'',
        remitImg:'',
        payid:''
      },
      headers:{
        token:window.sessionStorage.getItem('Token'),
      },
      qf_Balance:'',
      qf_account:'',
      qf_account:'',
      scenicbalance:'',
      navcharge:'',
      NoteSet:{
        token:window.sessionStorage.getItem('Token'),
        ExamineSms:'',
        fbalance:'',
        lbalance:'',
        frequency:'',
        sms_flag:'2'
      },
      ExamineSms:'',
      infor:{},
      dataqf:{
        token:window.sessionStorage.getItem('Token'),
        description:'',
        useBeginDate:'',
        useEndDate:''
      },
      datatks:{
        token: window.sessionStorage.getItem("Token"),
        text:'',
        sms_flag:'1',
        sms_template:'',
        Sms:''
      },
      type:1,
      days:'',
      show:false,
      items:'',
      datare:{
        token: window.sessionStorage.getItem("Token"),
        DistributorID:'',
        start_time:'',
        end_time:'',
        page:1,
        page_size:8
      },
      tableDatarefund:[],
      totalreund:0,
      valuerefund:[]
    };
  },
  created(){
        this.loading = true
        this.getList() // 获取短信列表
        this.Distrbutor() //获取分销商
        this.SMSnum()
        if(this.$route.query.id==1){
            this.tabTitle('0')
        }
        let data = {
          token:window.sessionStorage.getItem('Token'),
        }
        ScenicMessage(data).then((res) => {
          if (res.data.status == "ok") {
            this.infor = res.data.result;
          }
        });
  },
  methods: {
    reportClickrefund(){
      exportRefundSmsOrder(this.datare).then(res=>{
        if(res.data.rcode==200){
          window.location.href = res.data.result.url
        }
      })
    },
    reclick(){
      if(this.valuerefund){
        this.datare.start_time = this.valuerefund[0]
        this.datare.end_time = this.valuerefund[1]
      }else{
        this.datare.start_time = ''
        this.datare.end_time = ''
      }
      this.datare.page = 1
      this.getListrefund()
    },
    refundClose(){
      this.items = ''
      this.show = false
    },
    openClick(item){
      this.items = item
      this.show = true
      this.getListrefund()
    },
    Listrefund(e){
      this.datare.page = e
      this.getListrefund()
    },
    getListrefund(){
      this.datare.DistributorID = this.items.DistributorID
      refundSmsOrderList(this.datare).then(res=>{
        if(res.data.status=='ok'){
          this.tableDatarefund = res.data.result.data
          this.totalreund = res.data.result.total
        }
      })
    },
    getSmsDetail(){
      let data = {
          token:window.sessionStorage.getItem('Token'),
        }
      getQfTemplate(data).then((res) => {
          if (res.data.status == "ok") {
            this.dataqf.description  =  res.data.result.content
          }
        });
    },
    reportClick(){
      if(this.value1==''){
        this.$message.error('请选择时间')
        return false
      }
      if(this.days==''){
        this.$message.error('请输入天数')
        return false
      }
      let data = {
        start_time:this.value1[0],
        end_time:this.value1[1],
        token:window.sessionStorage.getItem('Token'),
        days:this.days,
        type:this.type
      }
      exportMobile(data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          let num = res.data.result.mobile_count * this.qf_Balance
          if(num>this.qf_account){
            this.getSMS()
            this.activeIndex = 0
            this.$message.error('群发余额不足，请充值')
            return false
          }
          window.location.href = res.data.result.url
        }
      })
    },
    settiTuikun(){
      if(this.datatks.text==''){
        this.$message.error('短信模板内容不能为空')
        return false
      }
      setSmsTemplate(this.datatks).then(res=>{
        if(res.data.rcode==200){
          Message.success('设置成功')
          this.noteSetDialogVisible = false
          this.data={
            token: window.sessionStorage.getItem("Token"),
            text:'',
            sms_flag:'1'
          }
          this.getListTuik()
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
     // 群发短信确认
    btns(){
      MessageBox('此操作将群发该短信, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let data = {
              token: window.sessionStorage.getItem("Token"),
              content:this.dataqf.description
            }
            addQfTemplate(data).then(res=>{
              if(res.data.status=='ok'){
                this.$message.success('发送成功')
                this.dataqf={
                  token:window.sessionStorage.getItem('Token'),
                  description:'',
                  useBeginDate:'',
                  useEndDate:''
                }
                this.value1 = ''
              }else{
                this.$message.error(res.data.msg)
              }
            })
        }).catch(() => {
                 
       });
     
    },
    clearqf(){
      this.hairMon = ''
      this.hairMoney = ''
    },
    clearCh(){
      this.price = ''
      this.form.chargeBal = ''
    },
    handlePreviewVide(res){
      this.formremi.remitImg = res.result
    },
    remiClick(){
      remitApi(this.formremi).then(res=>{
        if(res.data.status=='ok'){
          this.remittance = false
          Message.success('提交成功')
          this.formremi.remitImg = ''
          this.formremi.payid = ''
          this.remi.jfyAccount = ''
          this.remi.jfyAccountBank = ''
          this.remi.jfyName = ''
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    remiHandleClose(){
      this.remittance = false
      this.formremi.remitImg = ''
      this.formremi.payid = ''
      this.remi.jfyAccount = ''
      this.remi.jfyAccountBank = ''
      this.remi.jfyName = ''
    },
    hairClick(){
      if(this.hairMon==''||this.hairMon==0){
        this.$message.error('请输入充值金额')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        type:2,
        chargeTime:this.type=='2'?this.hairMonTime:'',
        payMode:this.radio,
        chargeBal:this.hairMon,
        qfBal:this.hairMon
      }
      SetSMStopup(data).then(res=>{
        if(res.data.status=='ok'){
          if(this.radio=='4'){
            let data = {
              token:window.sessionStorage.getItem('Token'),
            }
            getPayInfo(data).then(ren=>{
              if(ren.data.status=='ok'){
                this.formremi.payid = res.data.result
                this.remi.jfyAccount = ren.data.data.jfyAccount
                this.remi.jfyAccountBank = ren.data.data.jfyAccountBank
                this.remi.jfyName = ren.data.data.jfyName
              }
            })
            this.remittance =  true
            return false
          }
          let data = {
            token:window.sessionStorage.getItem('Token'),
            payid:res.data.result,
            scenicid:window.sessionStorage.getItem('ScenicId')
          }
          PaySMS(data).then(respone=>{
            if(respone.data.status=='ok'){
              if(this.radio=='2'){
                document.getElementById("qrcode").innerHTML = ''
                this.Visible = true
                this.creatQrCode(respone.data.result)
              }else if(this.radio=='3'){
                // document.write(respone.data.result)
                let divForm = document.getElementsByTagName('divform')
                if (divForm.length) {
                  document.body.removeChild(divForm[0])
                }
                const div = document.createElement('divform')
                div.innerHTML = respone.data.result // res.data就是sb支付宝返回给你的form
                document.body.appendChild(div)
                document.getElementById('alipaysubmit').target="_blank"
                document.getElementById('alipaysubmit').submit()
                MessageBox('充值完成?')
                .then(_ => {
                  console.log(1)
                })
                .catch(_ => {});
              }
            }
          })
        }
      })
    },
    creatQrCode(img){
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: img, // 需要转换为二维码的内容
            width: 150,
            height: 150,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        })
    },
    payment(){
      this.getSMS()
      this.Visible = false
    },
    closeFlag(){
      this.getSMS()
      this.Visible = false
    },
    inputPrice1(){
      if(this.type=='1'){
        // 计费
        // this.form.chargeBal = this.price
        this.hairMon = this.hairMoney
      }else{
        //  计时
        this.form.chargeTime = this.price
        // this.form.chargeBal = this.price * this.qf_Balance
        this.hairMonTime =  this.hairMoney 
        this.hairMon =  this.hairMoney 
      }
    },
    inputPrice(){
      if(this.type=='1'){
        // 计费
        this.form.chargeBal = this.price
        // this.hairMon = this.hairMoney
      }else{
        //  计时
        this.form.chargeTime = this.price
        this.form.chargeBal = this.price * this.commission
        // this.hairMonTime =  this.hairMoney 
        // this.hairMon =  this.hairMoney * this.commission
      }
    },
    Recharge(){
      if(this.form.chargeBal==''||this.form.chargeBal==0){
        this.$message.error('请输入充值金额')
        return false
      }
      SetSMStopup(this.form).then(res=>{
        if(res.data.status=='ok'){
          if(this.form.payMode=='4'){
            let data = {
              token:window.sessionStorage.getItem('Token'),
            }
            getPayInfo(data).then(ren=>{
              if(ren.data.status=='ok'){
                this.formremi.payid = res.data.result
                this.remi.jfyAccount = ren.data.data.jfyAccount
                this.remi.jfyAccountBank = ren.data.data.jfyAccountBank
                this.remi.jfyName = ren.data.data.jfyName
              }
            })
            this.remittance =  true
            return false
          }
          let data = {
            token:window.sessionStorage.getItem('Token'),
            payid:res.data.result,
            scenicid:window.sessionStorage.getItem('ScenicId')
          }
          PaySMS(data).then(respone=>{
            if(respone.data.status=='ok'){
              // respone.data.result
              if(this.form.payMode=='2'){
                document.getElementById("qrcode").innerHTML = ''
                this.Visible = true
                this.creatQrCode(respone.data.result)
              }else if(this.form.payMode=='3'){
                // document.write(respone.data.result)
                let divForm = document.getElementsByTagName('divform')
                if (divForm.length) {
                  document.body.removeChild(divForm[0])
                }
                const div = document.createElement('divform')
                div.innerHTML = respone.data.result // res.data就是sb支付宝返回给你的form
                document.body.appendChild(div)
                document.getElementById('alipaysubmit').target="_blank"
                document.getElementById('alipaysubmit').submit()
                MessageBox('充值完成?')
                .then(_ => {
                })
                .catch(_ => {});
              }
            }
          })
        }
      })
    },
    // 短信充值展示
    getSMS(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      GetSMStopup(data).then(res=>{
        if(res.data.status=='ok'){
          this.type = res.data.result.charge
          this.charge_des = res.data.result.charge_des
          this.Balance = res.data.result.balance
          this.charge_price = res.data.result.charge_price
          this.commission = res.data.result.commission
          this.qf_Balance = res.data.result.qf_price
          this.qf_account = res.data.result.qf_account
          // this.charge = res.data.result.charge
        }
      })
    },
    // 短信充值分页
    Rechange(e){
      this.loading = true
      this.data1.page = e
      this.getRechargeList()
    },
    // 短信充值查询
    RechargeBtns(){
      this.loading = true
      this.data1.page = 1
      this.total1 = 0
      if(this.SMStime){
        this.data1.starttime = this.SMStime[0] + ' 00:00:00'
        this.data1.endtime = this.SMStime[1] + ' 23:59:59'
      }else{
        this.data1.starttime = ''
        this.data1.endtime = ''
      }
      this.getRechargeList()
    },
    // 短信充值统计列表
    getRechargeList(){
      ScenicSMSstatistics(this.data1).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.scenicbalance = res.data.result.scenicbalance
          this.total1 = res.data.result.total
          this.loading = false
        }
      })
    },
    // 搜索
    setDisSMS(){
      this.loading = true
      this.total = 0
      this.data.page = 1
      if(this.dataTime){
        this.data.starttime = this.dataTime[0] + ' 00:00:00'
        this.data.endtime = this.dataTime[1] + ' 23:59:59'
      }else{
        this.data.starttime = ''
        this.data.endtime = ''
      }
      this.getList()
    },
    // 分销商选择器
    Distrbutor(){
     let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:999
      }
      getScenicListDistrbutor(data).then(res=>{
        if(res.data.status=='ok'){
          this.options = res.data.result.data
        }
      })
    },
    // 分页
    list(e){
      this.loading = true
      this.data.page = e
      this.getList()
    },
    getList(){
      DisSMSstatistics(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
          this.loading = false
        }
      })
    },
    // 短信统计查看详情
    noteFn(row) {
      this.noteTjvisible = true;
      this.noteId = row.DistributorID
      this.$nextTick(() => {
        this.$refs.noteTjDialog.noteInfo(row);
      });
    },
    // 关闭短信统计详情
    notClose(){
      this.noteTjvisible = false;
      this.noteId = ''
    },
    // 付款凭证
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    tabTitle(index) {
      if(this.activeIndex==index){
        return false
      }
      this.activeIndex = index;
      if(this.activeIndex=='2'){
        this.loading = true
        this.getList() // 获取短信列表
        this.Distrbutor() //获取分销商
        this.SMSnum()
      }else if(this.activeIndex=='1'){
        this.loading = true
        this.getRechargeList()
      }else if(this.activeIndex==0){
        this.getSMS()
      }else if(this.activeIndex=='3'){
        this.getListNote()
        this.getRechargeList()
      }else if(this.activeIndex=='5'){
        this.getListTuik()
      }else if(this.activeIndex==4){
        this.getSMS()
        this.getSmsDetail()
      }
    },
    getListTuik(){
      let data = {
        token: window.sessionStorage.getItem("Token"),
      }
      getSmsTemplate(data).then(res=>{
        if(res.data.rcode=='200'){
          this.datatks.sms_flag = res.data.result.sms_flag + ''
          this.datatks.text = res.data.result.sms_template
          this.datatks.Sms = res.data.result.Sms
        }
      })
    },
    getListNote(){
      let data={
        token: window.sessionStorage.getItem("Token"),
      }
      GetScenicNote(data).then(res=>{
        if(res.data.status=='ok'){
          this.ExamineSms = res.data.result.ExamineSms
          this.NoteSet = res.data.result
          this.NoteSet.ExamineSms = res.data.result.ExamineSms
          this.NoteSet.sms_flag +=''
        }
      })
    },
      // 短信设置确认
    settings(){
      this.NoteSet.token = window.sessionStorage.getItem('Token')
      this.NoteSet.ExamineSms = this.ExamineSms
      ScenicNoteSet(this.NoteSet).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('发送成功')
          this.getListNote()
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    SMSnum(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      this.navList = []
      SMSstatistics(data).then(res=>{
        if(res.data.status=='ok'){
          this.charge = res.data.result.charge
            if(res.data.result.charge=='2'){
              this.navList.push({
                id: 1,
                title: "开始时间",
                navTotal: res.data.result.startdate,
                srcUrl: require("@/images/scenic/dxgl.png")
              })  
              this.navList.push({
                id: 2,
                title: "结束时间",
                navTotal:  res.data.result.enddate,
                srcUrl: require("@/images/scenic/dxgl.png")
              }) 
            }else{
              this.navList.push({
                id: 3,
                title: "短信价格",
                navTotal:Number(res.data.result.Commission).toFixed(2),
                Company: "元",
                srcUrl: require("@/images/scenic/dxgl2.png")
              })  
              this.navList.push({
                id: 4,
                title: "短信剩余数量",
                navTotal: Number(res.data.result.residue_num).toFixed(2),
                Company: "条",
                srcUrl: require("@/images/scenic/dxgl.png")
              })
            }
        }
      })
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.btnS {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: unset;
  // margin-top: 31px;
  .el-button {
    width: 100px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 120px;
    background: #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
.ziZhuCZ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-left: -80px;
    margin-top: 31px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 120px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .zCLeft {
    width: 49%;
    padding: 20px;
    box-sizing: border-box;
    min-height: 740px;
    background: #ffffff;
    border-radius: 4px;
    .el-form-item {
      margin-bottom: 20px;
    }
    .Botm {
      margin-bottom: 0px;
    }
   
  
    .itemTwo {
      display: flex;
      flex-wrap: wrap;
      .el-input {
        // width: 267px;
      }
      span {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 10px;
      }
    }
    .itemOne {
      display: flex;
      flex-wrap: wrap;
     
          .el-input {
              width: 145px;
          }
      span {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        // margin-left: 10px;
      }
    }
    > div:nth-child(1) {
      width: 100%;
      height: 40px;
      line-height: 30px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
    }
    // 分割线
    /deep/.el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      // margin: 20px 0;
    }
  }
  .zCRight {
    width: 49%;
    height: 740px;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
    > div:nth-child(1) {
      width: 100%;
      height: 40px;
      line-height: 30px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
    }
    // 分割线
    /deep/.el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      // margin: 20px 0;
    }
  }
}
.navFrame {
  width: 100%;
  display: flex;
  margin: 17px 0;
  .navDataBig {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    > div {
      min-width: 280px;
      margin-bottom: 10px;
      width: 39rem;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
      margin-right: 1.8rem;
      &:last-child{
        margin-right: 0;
      }
      > div:nth-child(1) {
        width: 84px;
        height: 20px;
        margin-left: 20px;
        margin-top: 17px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        color: #666666;
      }
      > div:nth-child(2) {
        height: 56px;
        display: flex;
        margin-top: 40px;
        // background: red;
        img {
          width: 80px;
          height: 60px;
          margin-right: 20px;
        }
        span {
          width: 100%;
          height: 100px;
          margin-bottom: 20px;
          display: flex;
          > span:nth-child(1) {
            display: block;
            // width: 120px;
            height: 100%;
            line-height: 100px;
            margin-left: 21px;
            margin-right: 8px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 40px;
            line-height: 56px;
            /* identical to box height */
            color: #246deb;
          }
          > span:nth-child(2) {
            display: block;
            width: 20px;
            height: 100%;
            margin-top: 20px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */
            color: #797979;
          }
        }
      }
    }
  }
}
.balance {
  height: 18px;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #666666;
  margin-bottom: 20px;
  > span:nth-child(2) {
    color: #4d88ef;
    margin: 0 10px;
  }
}
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.conentRow {
  display: flex;
  margin-bottom: 20px;
  .el-date-editor {
    margin-right: 20px;
  }
  .el-input {
    width: 250px;
    margin-right: 20px;
  }
  .el-select {
    width: 220px;
    margin-right: 20px;
  }
  .conentBtn {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    border: none;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .conentBtn2 {
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    box-sizing: border-box;
  }
}

.qxsq {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    cursor: pointer;
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.itemTwo /deep/ .el-form-item__content{
  display: flex;
}
.mask{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .3);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mask_box{
  width: 400px;
  height: 300px;
  background: #fff;
  position: relative;
}
.mask_box /deep/ .dialog-footer{
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translate(-50%,0);
}
/deep/ .qrcode{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.mask_title{
  color: #333;
  font-size:16px;
  font-weight: 600;
  padding: 10px;
  text-align: center;
  position: relative;
}
.mask_title img{
  position: absolute;
  right: 10px;
  width: 15px;
  height: 15px;
  cursor: pointer;
}
.mayMode {
      > div:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      > div:nth-child(2) {
        line-height: 30px;
        width: 100%;
        min-height: 190px;
        padding: 20px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > div:nth-child(1) {
          width: 50%;
          /deep/.el-descriptions
            :not(.is-bordered)
            .el-descriptions-item__cell {
            padding-bottom: 4px;
          }
          /deep/.el-descriptions-item__label:not(.is-bordered-label) {
            margin-right: 10px;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
          /deep/.el-descriptions-item__content {
            word-break: break-word;
            overflow-wrap: break-word;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
          }
        }
        > div:nth-child(2) {
          width: 30%;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #e74c3c;
          > span:nth-child(1) {
            margin-right: 10px;
          }
        }
      }
    }
    .itemFour {
      // display: flex;
      // height: 175px;
      // flex-wrap: wrap;
      .el-input {
        // width: 300px;
      }
      .zhu {
        margin-top: 1rem;
        height: 30px;
        line-height: 25px;
      }
      > div:nth-child(2) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #e74c3c;
      }
    }
.remiFlex{
  display: flex;
  flex-direction: column;
}
.fukuanfang{
  margin-top: 10px;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}
/deep/ .el-upload,.el-upload img{
  width: 10rem;
  height: 7rem;
  border: 1px solid #E5E5EA;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-radio__label{
  color: #000000 !important;
}
.charge{
  .el-input{
    width: auto !important;
  }
}
.noteMObile {
  display: flex;
  height: 200px;
  .noteMObileOne {
    width: 350px;
    margin-right: 20px;
    > div:nth-child(1) {
      height: 40px;
      line-height: 40px;
      > span:nth-child(1) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        margin-right: 10px;
      }
      > span:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #3176ec;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      height: 158px;
      padding: 20px;
      box-sizing: border-box;
      background: #f7f7fa;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      word-break:break-all;
      color: #000000;
    }
  }
  .noteMObileTwo {
    width: 350px;
    height: 220px;
    > div:nth-child(1) {
      height: 40px;
      line-height: 40px;
      text-align: center;
      > span:nth-child(1) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        margin-right: 10px;
      }
      > span:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #7ad896;
      }
    }
    > div:nth-child(2) {
      /deep/.el-textarea__inner {
        width: 100%;
        height: 158px;
        padding: 20px;
        box-sizing: border-box;
        background: #f7f7fa;
        border-radius: 4px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        word-break:break-all;
        color: #000000;
        border: none;
      }
    }
  }
}
.noteFrom {
  .el-form-item {
    position: relative;
    &:nth-child(1){
      display: flex;
    }
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -10px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: 17px;
    color: #e74c3c;
  }
  .btn {
    // margin: 20px 100px 10px 0;
    margin-top: 10px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 120px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .el-form-item__label {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #666666;
  }
  .el-input {
    width: 280px;
  }
  > span:nth-child(2) {
    margin-left: 10px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  }
  .notetitle {
    height: 25px;
    margin: 20px 0 16px 0;
    > span:nth-child(1) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      margin-right: 20px;
      color: #000000;
    }
    > span:nth-child(2) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      margin-right: 10px;
      color: #e74c3c;
    }
    > span:nth-child(3) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      color: #e74c3c;
    }
  }
}
.setNotes{
  padding: 2rem;
  background: #fff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
::v-deep .el-textarea__inner {
    resize: none;
}
.Left5{
  margin-left: 0.5rem;
}
.balance{
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 20px;
  color: #666666;
  display: flex;
  align-items: center;
  span{
    color: #246deb;
  }
}
.editMsgFrom {
  width: 75rem;
  .itemOne {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    // line-height: 20px;
    color: #e74c3c;
    > span:nth-child(1) {
      margin-right: 10px;
    }
  }
  .btn {
    // margin: 20px 100px 10px 0;
    margin-top: 20px;
    margin-left: -100px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 120px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.reports{
  display: flex;
  align-items: center;
  ::v-deep .el-button{
    margin-left: 2rem;
  }
  span{
    color: #000000;
    display: block;
  }
}
.itemtimes{
  display: flex;
  >div{
      width: 50%;
  }
  ::v-deep .el-date-editor{
    width: 26rem;
  }
  ::v-deep .el-input{
    width: 12rem;
  }
}
.Dcb {
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
    margin-left: 20px;
  }
  .titleZxtj {
  margin-bottom: 20px;
  .el-button {
    width: 100px;
    border: none;
    background: #246deb;
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    margin-left: 20px;
  }
}
</style>